import styled from 'styled-components';
import { Device } from '../../constants/device';

export const FormRow = styled.div`
  display: flex;
  margin: 0 -15px;

  > * {
    flex: 1;
    margin: 0 15px 30px;
  }

  ${Device.downTablet} {
    flex-direction: column;
  }
`;
